import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';

import { RequestType } from '../../../types/enums';

const GetScheduleGroups = () =>
    request({
        url: ApiURL.Query.GetScheduleGroups,
        method: RequestType.GET,
    });

const GetGroupUsers = (params: any) =>
    request({
        url: ApiURL.Query.GetScheduleGroupUsers,
        method: RequestType.GET,
        params: params,
    });

const ScheduleGroupsQuery = {
    GetScheduleGroups,
    GetGroupUsers,
};

export default ScheduleGroupsQuery;
